import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {WorkspaceSolutionsComponent} from '@features/workspace/components/workspace-solutions/workspace-solutions.component';
import {WorkspaceUsersComponent} from '@features/workspace/components/workspace-users/workspace-users.component';
import {WorkspaceFailureBannerComponent} from '@features/workspace/components/workspace-failure-banner/workspace-failure-banner.component';
import {ManageWorkspaceSolutionCommandHandler} from '@features/workspace/handlers/manage-workspace-solution-command-handler';

export class WorkspaceDynamicComponentHelper {
  static components: any;

  static create(): void {

  }

  public static init() {
    if (WorkspaceDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['WorkspaceSolutionsComponent'] = WorkspaceSolutionsComponent;
    components['WorkspaceUsersComponent'] = WorkspaceUsersComponent;
    components['WorkspaceFailureBannerComponent'] = WorkspaceFailureBannerComponent;
    WorkspaceDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    WorkspaceDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }

  public static getComponentArray(): any[] {
    WorkspaceDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(WorkspaceDynamicComponentHelper.components).forEach(key => {
      componentArray.push(WorkspaceDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }

}
